/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Doors_GateInputs */



/**
* | output |
* | --- |
* | "Collected at the door" |
*
* @param {Tournament_Wiz_Doors_GateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_doors_gate = /** @type {((inputs?: Tournament_Wiz_Doors_GateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Doors_GateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Encaissé sur place")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se cobra en la puerta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cobrada na entrada")
	if (locale === "it") return /** @type {LocalizedString} */ ("Riscossa all'ingresso")
	return /** @type {LocalizedString} */ ("Collected at the door")
});